<template>
	<div>
		<div v-if="show==true" class="gray">
			<div class="dialog">
				<div style="display:inline-block; width:100%;">
					<p class="title">{{title}}</p>
					<p class="cancel" v-on:click="cancel()"><font-awesome-icon icon="times" /></p>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<p v-if="paragraph!=''" class="paragraph">{{paragraph}}</p>
					<autocomplete
						v-if="autocompleteId!=-1"
						v-model=autocompleteData
						:type="autocompleteId"
					/>
				</div>
				<hr v-if="html!=''"/>
				<div v-if="html!=''" id="dialog_html" style="display:inline-block; width:100%;">
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<button class="buttons" v-for="button_name in button_names" v-on:click="button(button_name)">{{button_name}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		button_names: {
			type: Array,
			required: false,
			default: []
		},
		title: {
			type: String
		},
		paragraph: {
			type: String
		},
		show: {
			type: Boolean,
			required:false,
			default:true,
		},
		autoClose: {
			type: Boolean,
			required:false,
			default:true,
		},
		html: {
			type: String,
			required:false,
			default:"",
		},
		autocompleteId: {
			type: Number,
			required:false,
			default:-1,
		},
    },
	data() {
		return {
			autocompleteData:'',
		}
	},
	methods:{
		async button(buttonname){
			this.$emit('dialogue',  buttonname, this.autocompleteData);
			if(this.autoClose){
				this.cancel();
			}
		},
		async cancel(){
			this.$emit('cancel');
		}
	},
	watch:{
		show(){
			this.$nextTick(function () {
				this.autocompleteData = '';
				if(this.html!=""){
					var dialog_html = document.getElementById("dialog_html");
					dialog_html.innerHTML = this.html;
				}
			})
		},
	}
}
</script>

<style scoped>

.dialog{
	position:fixed;
	background-color:white;
	left: 50%;
	top:20vh;
	min-width:500px;
	transform: translateX(-50%);
	padding:15px;
	border:1px solid black;
	border-radius: 5px;
	box-shadow: 2px 2px;
}

.title{
	font-size: 40px;
	font-weight: bold;
	float:left;
	margin:0px;
}

.cancel{
	float:right;
	width:30px;
	text-align: center;
	font-size:24px;
}
.cancel:hover{
	color:#5c5e70;
}

.paragraph{
	font-size:22px;
	margin:0px;
	white-space: pre-wrap;
}

.buttons{
	float:right;
	font-size:18px;
}

.gray {
	display: absolute;
	position: fixed;
	z-index: 2;
	padding-top: 100px;
	left: 0;
	top: 0;
	width:100%;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.5);
}

.textfield{
    width:100%;
	height:150px;
	min-height:75px;
	max-height:375px;
}

</style>

<!--
EXAMPLE

<dialogue
	:title="'Delete'"
	:paragraph="'Are you sure you want to delete Techdoc '+term+'?'"
	:button_names="['Delete']"
	:show="delete_dialogue"
	v-on:dialogue="deleteTechdoc"
	v-on:cancel="cancelDelete"
></dialogue>

data{
	delete_dialogue:false,
}

async cancelDelete(){
	this.delete_dialogue=false;
},
async deleteTechdocDialogue(optional_buttonname){
	this.delete_dialogue=true;
},

-->



// WEBPACK FOOTER //
// src/layouts/dialogue.vue